/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CustomerUserService,
  type Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { INSTANCE_TENANT_SCOPE } from '../../constants/tenantScope';

const useAssignInstanceUserRole = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  customerUserId: string
): UseMutationResult<
  Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto | undefined,
  unknown,
  { customerRoleId: string | null },
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: { customerRoleId: string | null }) => {
      return await handleRequest(
        CustomerUserService.putApiCustomerApiAppCustomerUserCustomerUser({
          id: customerUserId,
          customerRoleId: payload.customerRoleId,
          scope: INSTANCE_TENANT_SCOPE,
        })
      );
    },
    {
      onSuccess: async (response, variables) => {
        if (response != null) {
          closeModal();
          const message =
            variables.customerRoleId == null || variables.customerRoleId === ''
              ? 'Instance role removed.'
              : 'Instance role assigned.';
          toast.success(<ToastComponent label='Success' message={message} />);
          await queryClient.invalidateQueries('getAllCustomerUserList');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useAssignInstanceUserRole;
